import { Injectable } from '@angular/core';

Injectable()
export class AppConfig{
  isprod = false;

  baseUrl = window.location.protocol + "//" + window.location.host;

  public api_cnn = (this.baseUrl == 'http://127.0.0.1:4200' || this.baseUrl == 'http://127.0.0.1:100030' ||
    this.baseUrl == 'http://127.0.0.1:10002' || this.baseUrl == 'http://127.0.0.1:10001' ||
    this.baseUrl == 'http://70.38.63.69:18000' || this.baseUrl == 'http://70.38.63.70:18000' || this.baseUrl == 'http://67.205.93.24:18000') ?
    this.isprod = false :
    this.isprod = true ;


  PATH_URL_WEB            = (!this.isprod )?'http://70.38.63.70:18081/':   'http://70.38.63.70:19081/' ;
  //PATH_URL_WEB          = (!this.isprod) ? 'http://localhost:59405/' : 'http://localhost:59405/';

  API_URL_WEB             = (!this.isprod )?'http://70.38.63.70:18081/api/':   'http://70.38.63.70:19081/api/' ;
  //API_URL_WEB             = (!this.isprod) ? 'http://localhost:59405/api/' : 'http://localhost:59405/api/';

  API_URL_Validacion = (!this.isprod) ? 'http://70.38.63.70:18081/api/' : 'http://70.38.63.70:19081/api/';
  //API_URL_Validacion      = (!this.isprod) ? 'http ://localhost:59405/' : 'http://70.38.63.69:59405/api/';

  API_URL_Carga = (!this.isprod) ? 'http://70.38.63.70:18081/api/' : 'http://70.38.63.70:19081/api/';
  //API_URL_Carga = (!this.isprod) ? 'http://localhost:59405/api/' : 'http://localhost:59405/api/';

  API_URL_POServicios     = (!this.isprod )? 'http://70.38.63.70:18083/api/':  'http://70.38.63.70:19083/api/' ;
  //API_URL_POServicios     = (!this.isprod) ? 'http://localhost:53154/api/' : 'http://70.38.63.69:19083/api/';

  API_URL_Sincronizacion = (!this.isprod) ? 'http://70.38.63.70:18084/api/' : 'http://70.38.63.70:19084/api/';
  //API_URL_Sincronizacion = (!this.isprod) ? 'http://localhost:50855/api/' : 'http://localhost:50855/api/';

  API_URL_NotaCredito     = (!this.isprod) ?  'http://70.38.63.70:18087/api/':  'http://70.38.63.70:19087/api/' ;
  //API_URL_NotaCredito = (!this.isprod) ? 'http://localhost:53653/api/' : 'http://70.38.63.69:19087/api/';

  API_URL_Consignacion    = (!this.isprod )? 'http://70.38.63.70:18088/api/':  'http://70.38.63.70:19088/api/' ;
  //API_URL_Consignacion = (!this.isprod) ? 'http://localhost:22509/api/' : 'http://localhost:22509/api/';

  API_URL_Yii    = (!this.isprod )? 'http://70.38.63.70:70/smp_qa/api/':  'http://70.38.63.70:70/smp/api/' ;

  API_URL_PROD = 'https://proveedoresclickcore.azurewebsites.net/api/';
  API_URL_DEV = 'http://localhost/vfJeans/api/web/app_dev.php/api/vf/';

}
